import React from "react";
import PropTypes from "prop-types";
import {Redirect, Route} from "react-router-dom";

const PrivateRoute = ({component: Component, auth, requirePermission, exact, path, ...rest}) => (
  <Route
    exact={exact}
    path={path}
    render={props => {
      if (!auth.isReady()) return null;
      if (!auth.isAuthenticated()) return (
        <Redirect to={{
          pathname: "/login",
          state: {from: props.location}
        }}/>
      );
      if (requirePermission && !auth.hasPermission(requirePermission)) return (
        <div>Permission denied</div>
      );
      return (
        <Component {...props} {...rest} auth={auth}/>
      );
    }}
  />
);
PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  requirePermission: PropTypes.string,
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
  location: PropTypes.object,
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/PrivateRoute.js